import React from 'react';
import { useForm } from 'react-hook-form';
import { Stack, Tooltip, Typography } from '@mui/material';
import { InfoOutlined } from '@mui/icons-material';
import { SwitchField } from 'components/form/rhf';
import { SmartSubmitFormValues } from '../types';

interface Props {
  isLoading: boolean;
  defaultValues: SmartSubmitFormValues;
  onConfirm: (values: SmartSubmitFormValues) => Promise<void>;
}

const label = (
  <Stack direction="row" alignItems="center" gap={0.5}>
    <Typography variant="body2">Enable Smart Submit for all account users</Typography>
    <Tooltip
      arrow
      title="When enabled, every user under this account will be switched to Smart Submit mode in Cognito. When disabled, they will be reverted to the standard internal type."
    >
      <InfoOutlined fontSize="small" color="action" sx={{ cursor: 'help' }} />
    </Tooltip>
  </Stack>
);

export const SmartSubmitForm = ({ isLoading, defaultValues, onConfirm }: Props) => {
  const { control, handleSubmit } = useForm<SmartSubmitFormValues>({ defaultValues });

  return (
    <SwitchField<SmartSubmitFormValues>
      control={control}
      name="smartSubmitEnabled"
      label={label}
      disabled={isLoading}
      extraAction={() => handleSubmit(onConfirm)()}
    />
  );
};
